/* oxlint-disable @typescript-eslint/restrict-template-expressions */
import type { ClientGPSLocation } from '@DigitaleDoerfer/digitale-doerfer-api';
import { openURL } from 'expo-linking';
import { openBrowserAsync } from 'expo-web-browser';

import { isWeb, isAndroid, isIOS } from '@/shared/utils/platform';
import { isEmptyOrNull } from '@/shared/utils/string';

type OpenUrlOptions = {
  /**
   * How to open the URL on native. `browser` (default) uses the in-app browser
   * (`expo-web-browser`); `system` hands the URL to the OS so the appropriate
   * app takes over — used for App Store / Play Store links.
   */
  native?: 'browser' | 'system';
};

export const handleOpenUrl = async (url?: string, options?: OpenUrlOptions) => {
  if (isEmptyOrNull(url)) return;

  try {
    if (isWeb) {
      window.open(url, '_blank');
      return;
    }
    if (options?.native === 'system') {
      await openURL(url);
    } else {
      await openBrowserAsync(url);
    }
  } catch (error) {
    console.error(
      `[URL_UTILS]: something went wrong while opening the url ${url}: \nERROR: \n ${error}`
    );
  }
};

export const handleOpenGps = async (gps?: ClientGPSLocation) => {
  if (!gps) return;

  try {
    if (isAndroid) {
      await openURL(
        `https://www.google.com/maps/search/?api=1&query=${gps?.latitude}%2C${gps?.longitude}`
      );
    }
    if (isIOS) {
      await openURL(
        `https://maps.apple.com/?q=${gps?.latitude},${gps?.longitude}`
      );
    }
    if (isWeb) {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${gps?.latitude}%2C${gps?.longitude}`,
        '_blank'
      );
    }
  } catch (error) {
    console.error(
      `[URL_UTILS]: something went wrong while opening gps coordinate ${JSON.stringify(gps)}: \nERROR: \n ${error}`
    );
  }
};

export const handleOpenEmailAddress = async (emailAddress?: string) => {
  if (isEmptyOrNull(emailAddress)) return;

  try {
    await openURL(`mailto:${emailAddress}`);
  } catch (error) {
    console.error(
      `[URL_UTILS]: something went wrong while opening email address ${emailAddress}: \nERROR: \n ${error}`
    );
  }
};

export const handleOpenPhoneNumber = async (phoneNumber?: string) => {
  if (isEmptyOrNull(phoneNumber)) return;

  try {
    await openURL(`tel:${phoneNumber}`);
  } catch (error) {
    console.error(
      `[URL_UTILS]: something went wrong while opening phone number ${phoneNumber}: \nERROR: \n ${error}`
    );
  }
};
